import {
  CloseOutlined,
  CrownOutlined,
  SearchOutlined,
  StockOutlined,
  MenuUnfoldOutlined,
  LogoutOutlined,
  PartitionOutlined,
} from "@ant-design/icons";
import { Affix, Button, Image, MenuProps } from "antd";
import { Layout, Menu } from "antd";

import { PLACEHOLDERS } from "constants/Placeholders";
import { useAppSelector } from "hooks/reduxHooks";
import { RoleIcon } from "icons/Icons";
import React, { useState } from "react";
import { Link, Outlet } from "react-router-dom";

const { Content, Sider } = Layout;

const items: any[] = [
  {
    label: "Analytics",
    key: "analytics",
    url: "/analytics",
    icon: <StockOutlined />,
  },
  {
    label: "Searches",
    key: "search",
    icon: <SearchOutlined />,
    url: "/search/initiate-search",
    children: [
      // {
      //   title: "Start New Search",
      //   key: "search-home",
      //   url: "search/initiate-search",
      // },
      {
        title: "Search By Name",
        key: "search-by-name",
        url: "search/search-by-name",
      },
      {
        title: "Recent Searches",
        key: "recent-search-log",
        url: "/search/recent-search-log",
      },
      {
        title: "Saved Searches",
        key: "saved-search",
        url: "/search/saved-search",
      },
    ],
  },
  {
    label: "View Projects",
    key: "Project",
    url: "/roles/list",
    icon: <RoleIcon />,
  },
  {
    label: "Talent Pools",
    key: "pipeline",
    url: "/pipeline/list",
    icon: <CrownOutlined />,
  },
  {
    label: "Integrations",
    key: "integrations",
    url: "/integrations/list",
    icon: <PartitionOutlined />,
  },
];

const MainLayout: React.FC = () => {
  const sideBarWidth = "256";
  const [collapsed, setCollapsed] = useState(false);

  const user: any = useAppSelector((state) => state.user.user);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
        width={sideBarWidth}
      >
        <Affix>
          <div style={{ position: "relative" }}>
            <div
              className={collapsed ? "logo-wrapper-collapse" : "logo-wrapper"}
            >
              <Link to={"/"}>
                <div className="logo">
                  {collapsed ? (
                    <Image height={"100%"} src="/logo.png" preview={false} />
                  ) : (
                    <Image
                      className="login-card"
                      style={{ margin: "auto", width: "181px" }}
                      src="/sinecure-logo.png"
                      preview={false}
                    />
                  )}
                </div>
              </Link>
              {!collapsed ? (
                <Link
                  to={"#"}
                  onClick={() => {
                    setCollapsed(true);
                  }}
                >
                  <CloseOutlined />
                </Link>
              ) : (
                ""
              )}
              {collapsed ? (
                <>
                  <br />
                  <Button
                    icon={<MenuUnfoldOutlined />}
                    shape="circle"
                    type="primary"
                    onClick={() => {
                      setCollapsed(false);
                    }}
                  ></Button>

                  <br />
                </>
              ) : (
                ""
              )}
            </div>
            <br />
            <br />
            <p className="name-wrapper">
              {" "}
              <Image
                width={40}
                style={{ marginRight: 15 }}
                src={
                  user.profile_picture
                    ? user.profile_picture
                    : PLACEHOLDERS.blank_avatar
                }
                preview={false}
                fallback={PLACEHOLDERS.placeholder_image}
              ></Image>
              {!collapsed ? (
                <span
                  className="label"
                  style={{ marginLeft: 15, color: "#003a8c" }}
                >
                  {"Hello" + " "}{" "}
                  <strong style={{ color: "#1890FF" }}>
                    {user.first_name}
                  </strong>
                </span>
              ) : (
                ""
              )}
            </p>
            <br />
            <br />
            <br />
            <Menu
              theme="light"
              defaultSelectedKeys={["1"]}
              mode="inline"
              defaultOpenKeys={["search"]}
            >
              {items.map((nav) =>
                nav.children && nav.children.length > 0 ? (
                  <Menu.SubMenu
                    key={nav.key}
                    title={nav.label}
                    icon={nav.icon}
                    onTitleClick={() => setCollapsed(false)}
                    popupClassName="d-none"
                  >
                    {nav.children.map((childNav: any) => (
                      <Menu.Item
                        key={childNav.key}
                        title=""
                        className="submenu-back"
                      >
                        <Link className="no-underline" to={childNav.url || ""}>
                          {childNav.title}
                        </Link>
                      </Menu.Item>
                    ))}
                  </Menu.SubMenu>
                ) : (
                  <Menu.Item key={nav.key} title="" icon={nav.icon}>
                    <Link className="no-underline" to={nav.url || ""}>
                      {nav.label}
                    </Link>
                  </Menu.Item>
                )
              )}
            </Menu>
            <div
              className="log-out ant-menu-item"
              style={{ width: !collapsed ? sideBarWidth : "80" + "px" }}
            >
              <Link to="/logout">
                <LogoutOutlined />
                {!collapsed ? (
                  <span className="ant-menu-title-content">Logout</span>
                ) : (
                  ""
                )}
              </Link>
            </div>
          </div>
        </Affix>
      </Sider>
      <Layout className="site-layout">
        <Content>
          <div style={{ minHeight: "100vh" }}>
            <Outlet></Outlet>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
